// 自定义页面头部配置 https://qm-base.qmniu.com/h5-ui/#/q-navigation#api
export const navConfig = {
    title: '第二届527七猫小说节·阅读马拉松',
    fullScreen: true,
    menuConfig: {
        right: [
            {
                icon: '&#xe65f;',
                type: 'share',
            }
        ],
    },
    // beginBufferNumber: 1,
    // endBufferRatio: 1, // 两个都为1，表示不显示过渡效果（透明度）
    styleConfig: {
        default: {
            text: {
                color: '#111',
                opacity: 1,
            },
            title: {
                color: '#111',
                opacity: 1,
            },
            bg: {
                background: 'transparent',
            },
            statusBar: 'black',
        },
        fixed: {
            text: {
                color: '#111',
                opacity: 1,
            },
            title: {
                color: '#111',
                opacity: 1,
            },
            bg: {
                background: 'transparent',
            },
            statusBar: 'black',
        },
    },
};

// 奖杯对应的坐标
export enum trophyPoint {
    mini = 10,
    half = 21,
    full = 42,
}

// 起点位置
export const basePosition = { x: 144, y: 2428, };
// 最大位置
export const maxPosition = { x: 54, y: 341, };
// 地图发生变动需调整坐标
// 宝箱坐标列表
export const prizePositionList = [
    { x: 67, y: 2405, }, // 1km
    { x: 149, y: 2359, }, // 2km
    { x: 62, y: 2309, }, // 3km
    { x: 150, y: 2264, }, // 4km
    { x: 231, y: 2223, }, // 5km
    { x: 146, y: 2179, }, // 6km
    { x: 62, y: 2140, }, // 7km
    { x: 133, y: 2092, }, // 8km
    { x: 42, y: 2039, }, // 9km
    { x: 124, y: 1994, }, // 10km
    { x: 215, y: 1946, }, // 11km
    { x: 135, y: 1903, }, // 12km
    { x: 46, y: 1858, }, // 13km
    { x: 132, y: 1813, }, // 14km
    { x: 215, y: 1771, }, // 15km
    { x: 134, y: 1723, }, // 16km
    { x: 213, y: 1676, }, // 17km
    { x: 129, y: 1633, }, // 18km
    { x: 44, y: 1590, }, // 19km
    { x: 131, y: 1544, }, // 20km
    { x: 212, y: 1501, }, // 21km
    { x: 124, y: 1455, }, // 22km
    { x: 40, y: 1415, }, // 23km
    { x: 119, y: 1370, }, // 24km
    { x: 42, y: 1326, }, // 25km
    { x: 130, y: 1282, }, // 26km
    { x: 213, y: 1240, }, // 27km
    { x: 132, y: 1196, }, // 28km
    { x: 44, y: 1152, }, // 29km
    { x: 126, y: 1109, }, // 30km
    { x: 216, y: 1065, }, // 31km
    { x: 141, y: 1021, }, // 32km
    { x: 215, y: 975, }, // 33km
    { x: 131, y: 932, }, // 34km
    { x: 47, y: 890, }, // 35km
    { x: 122, y: 843, }, // 36km
    { x: 47, y: 799, }, // 37km
    { x: 130, y: 755, }, // 38km
    { x: 215, y: 710, }, // 39km
    { x: 134, y: 667, }, // 40km
    { x: 47, y: 626, }, // 41km
    { x: 135, y: 576, }, // 42km
    { x: 225, y: 531, }, // 43km
    { x: 152, y: 486, }, // 44km
    { x: 222, y: 438, }, // 45km
    { x: 133, y: 394, } // 46km
];

// 七仔坐标列表 [宝箱前坐标, 宝箱后坐标]
export const personPositionList = [
    [
        { x: 57, y: 2393, },
        { x: 84, y: 2379, }
    ], // 1km
    [
        { x: 127, y: 2347, },
        { x: 132, y: 2331, }
    ], // 2km
    [
        { x: 52, y: 2297, },
        { x: 79, y: 2283, }
    ], // 3km
    [
        { x: 130, y: 2254, },
        { x: 167, y: 2238, }
    ], // 4km
    [
        { x: 209, y: 2211, },
        { x: 214, y: 2195, }
    ], // 5km
    [
        { x: 166, y: 2169, },
        { x: 129, y: 2151, }
    ], // 6km
    [
        { x: 52, y: 2128, },
        { x: 79, y: 2114, }
    ], // 7km
    [
        { x: 111, y: 2080, },
        { x: 116, y: 2064, }
    ], // 8km
    [
        { x: 32, y: 2027, },
        { x: 59, y: 2013, }
    ], // 9km
    [
        { x: 104, y: 1984, },
        { x: 141, y: 1968, }
    ], // 10km
    [
        { x: 193, y: 1934, },
        { x: 198, y: 1918, }
    ], // 11km
    [
        { x: 155, y: 1893, },
        { x: 118, y: 1875, }
    ], // 12km
    [
        { x: 36, y: 1846, },
        { x: 63, y: 1832, }
    ], // 13km
    [
        { x: 112, y: 1803, },
        { x: 149, y: 1787, }
    ], // 14km
    [
        { x: 193, y: 1759, },
        { x: 198, y: 1743, }
    ], // 15km
    [
        { x: 124, y: 1711, },
        { x: 151, y: 1697, }
    ], // 16km
    [
        { x: 191, y: 1664, },
        { x: 196, y: 1648, }
    ], // 17km
    [
        { x: 149, y: 1623, },
        { x: 112, y: 1605, }
    ], // 18km
    [
        { x: 34, y: 1578, },
        { x: 61, y: 1564, }
    ], // 19km
    [
        { x: 111, y: 1534, },
        { x: 148, y: 1518, }
    ], // 20km
    [
        { x: 190, y: 1489, },
        { x: 195, y: 1473, }
    ], // 21km
    [
        { x: 144, y: 1445, },
        { x: 107, y: 1427, }
    ], // 22km
    [
        { x: 30, y: 1403, },
        { x: 57, y: 1389, }
    ], // 23km
    [
        { x: 97, y: 1358, },
        { x: 102, y: 1342, }
    ], // 24km
    [
        { x: 32, y: 1314, },
        { x: 59, y: 1300, }
    ], // 25km
    [
        { x: 110, y: 1272, },
        { x: 147, y: 1256, }
    ], // 26km
    [
        { x: 191, y: 1228, },
        { x: 196, y: 1212, }
    ], // 27km
    [
        { x: 152, y: 1186, },
        { x: 115, y: 1168, }
    ], // 28km
    [
        { x: 34, y: 1140, },
        { x: 61, y: 1126, }
    ], // 29km
    [
        { x: 106, y: 1099, },
        { x: 143, y: 1083, }
    ], // 30km
    [
        { x: 194, y: 1053, },
        { x: 199, y: 1037, }
    ], // 31km
    [
        { x: 131, y: 1009, },
        { x: 158, y: 995, }
    ], // 32km
    [
        { x: 193, y: 963, },
        { x: 198, y: 947, }
    ], // 33km
    [
        { x: 151, y: 922, },
        { x: 114, y: 904, }
    ], // 34km
    [
        { x: 37, y: 878, },
        { x: 64, y: 864, }
    ], // 35km
    [
        { x: 100, y: 831, },
        { x: 105, y: 815, }
    ], // 36km
    [
        { x: 37, y: 787, },
        { x: 64, y: 773, }
    ], // 37km
    [
        { x: 110, y: 745, },
        { x: 147, y: 729, }
    ], // 38km
    [
        { x: 193, y: 698, },
        { x: 198, y: 682, }
    ], // 39km
    [
        { x: 154, y: 657, },
        { x: 117, y: 639, }
    ], // 40km
    [
        { x: 37, y: 614, },
        { x: 64, y: 600, }
    ], // 41km
    [
        { x: 115, y: 566, },
        { x: 152, y: 550, }
    ], // 42km
    [
        { x: 203, y: 519, },
        { x: 208, y: 503, }
    ], // 43km
    [
        { x: 142, y: 474, },
        { x: 169, y: 460, }
    ], // 44km
    [
        { x: 200, y: 426, },
        { x: 205, y: 410, }
    ], // 45km
    [
        { x: 153, y: 384, },
        { x: 116, y: 366, }
    ] // 46km
];

// 奖杯坐标
export const trophyPosition = [
    { x: 77, y: 531, type: 'full', },
    { x: 247, y: 1457, type: 'half', },
    { x: 74, y: 1954, type: 'mini', }
];

// 奖杯提示文案
export const trophyBubblePosition = [
    { x: 16, y: 489, type: 'full', title: '全程马拉松', openTime: 1779879600000, },
    { x: 232, y: 1425, type: 'half', title: '半程马拉松', openTime: 1779879600000, },
    //每周日19点 05-03   05-10  05-17  05-24
    { x: 11, y: 1949, type: 'mini', title: '迷你马拉松', openTimes: [1777806000000, 1778410800000, 1779015600000, 1779620400000], }
];

export const ruleLink = 'https://xiaoshuo.wtzw.com/freereader-rules/69d63cd5225840ebf8fc2488/?side_panel=1';

// 特殊站点对应的书籍
export const siteBookMap: Record<number, any> = {
    2: {
        icon: 'site-thttj',
        name: '太荒吞天诀',
        author: '铁马飞桥',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/bcf49669665ef6575e2c64b0147bf308.jpg?x-oss-process=image/resize,w_200',
        id: '195631',
        clickable: true,
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-thttj.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-thttj.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-thttj.png',
            title: '《太荒吞天诀》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达2公里，解锁《太荒吞天诀》补给站得专属签名卡',
    },

    6: {
        icon: 'site-jl',
        name: '剑来',
        author: '烽火戏诸侯',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/48ba9dcedabc52a926ad746a6d12b03c.jpg?x-oss-process=image/resize,w_200',
        id: '143170',
        clickable: true,
        popContentBg: '#FFECEC',
        popTextColor: '#6B1F1F',
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-jl.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-default.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-jl.png',
            title: '《剑来》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达6公里，解锁《剑来》补给站得专属签名卡',
    },
    12: {
        icon: 'site-tx',
        name: '踏星',
        author: '随散飘风',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/3971e76027b37ab7a76fac145a1df155.jpg?x-oss-process=image/resize,w_200',
        id: '147998',
        clickable: true,
        popContentBg: '#FFECEC',
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-tx.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-default.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-tx.png',
            title: '《踏星》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达12公里，解锁《踏星》补给站得专属签名卡',
    },
    18: {
        icon: 'site-lhh',
        name: '离婚后她惊艳了世界',
        author: '明婳',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/ad1213f86b392805bda0cc67ddcf90d2.jpg?x-oss-process=image/resize,w_200',
        id: '222767',
        clickable: true,
        popContentBg: '#EEECFF',
        popTextColor: '#6B51A5',
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-lhh.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-lhh.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-lhh.png',
            title: '《离婚后惊艳了世界》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达18公里，解锁《离婚后惊艳了世界》补给站得专属签名卡',
    },
    28: {
        icon: 'site-brjs',
        name: '不让江山',
        author: '知白',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/f2ae66dad51d7448d69b72bdc9287506.jpg?x-oss-process=image/resize,w_200',
        id: '195626',
        clickable: true,
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-brjs.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-brjs.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-brjs.png',
            title: '《不让江山》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达28公里，解锁《不让江山》补给站得专属签名卡',
    },
    32: {
        icon: 'site-tjl',
        name: '天骄录',
        author: '喵喵大人',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/e922f2ea598353e07bb34f9d41611947.jpg?x-oss-process=image/resize,w_200',
        id: '2087274',
        clickable: true,
        popContentBg: '#FFECF5',
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-tjl.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-tjl.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-tjl.png',
            title: '《天骄录》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达32公里，解锁《天骄录》补给站得专属签名卡',
    },
    36: {
        icon: 'site-zsqm',
        name: '掌上齐眉',
        author: '锦一',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/eecab135582118e40efa33b8b57c42b8.jpg?x-oss-process=image/resize,w_200',
        id: '211498',
        clickable: true,
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-zsqm-2.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-zsqm.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-zsmz.png',
            title: '《掌上齐眉》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达36公里，解锁《掌上齐眉》补给站得专属签名卡',
    },
    40: {
        icon: 'site-wdtm',
        name: '无敌天命',
        author: '青鸾峰上',
        img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/de1aaec94b53946e85c363581fa34152.jpg?x-oss-process=image/resize,w_200',
        id: '1862264',
        clickable: true,
        popContentBg: '#FFECEC',
        popTitle: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-title-img-wdtm.png',
        popBtn: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-btn-default.png',
        prize: {
            pic: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/marathon/pop-card-wdtm.png',
            title: '《无敌天命》专属签名卡',
            level: 3,
        },
        prizeDesc: '活动里程到达40公里，解锁《无敌天命》补给站得专属签名卡',
    },
};

// 地图两边热区
export const mapHotArea = [
    // 天骄录
    {
        isLeft: true,
        y: 964,
        points: [
            [0, 0],
            [0, 209],
            [127, 162],
            [127, 52]
        ],
        site: 32,
        w: 127,
        h: 209,
    },
    // 离婚后
    {
        isLeft: true,
        y: 1669,
        points: [
            [0, 0],
            [0, 200],
            [127, 158],
            [127, 54]
        ],
        site: 18,
        w: 127,
        h: 200,
    },
    // 剑来
    {
        isLeft: true,
        y: 2187,
        points: [
            [0, 0],
            [0, 160],
            [146, 124],
            [146, 68]
        ],
        site: 6,
        w: 146,
        h: 160,
    },
    // 无敌天命
    {
        isLeft: false,
        y: 592,
        points: [
            [0, 64],
            [0, 123],
            [130, 174],
            [130, 0]
        ],
        site: 40,
        w: 130,
        h: 174,
    },
    // 掌上齐眉
    {
        isLeft: false,
        y: 804,
        points: [
            [0, 63],
            [0, 147],
            [130, 199],
            [130, 0]
        ],
        site: 36,
        w: 130,
        h: 199,
    },
    // 不让江山
    {
        isLeft: false,
        y: 1117,
        points: [
            [0, 56],
            [0, 126],
            [118, 173],
            [130, 0]
        ],
        site: 28,
        w: 118,
        h: 173,
    },
    // 踏星
    {
        isLeft: false,
        y: 1827,
        points: [
            [0, 66],
            [0, 112],
            [135, 173],
            [135, 0]
        ],
        site: 12,
        w: 135,
        h: 173,
    },
    // 太荒吞天决
    {
        isLeft: false,
        y: 2287,
        points: [
            [0, 60],
            [0, 113],
            [112, 134],
            [112, 0]
        ],
        site: 2,
        w: 112,
        h: 134,
    }
];

type NormalSiteBookItem = {
    filterId: string;
    author: string;
    img: string;
    name: string;
    id: string;
};

// 普通站点书籍默认数据
const normalSiteBookDefaultRaw: NormalSiteBookItem[] = [
    { filterId: '1658048', author: '相思一顾', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/1dd3c2253549f9f2bb09235536c96740.jpg?x-oss-process=image/resize,w_200', name: '六年后，我携四个幼崽炸翻前夫家番外', id: '11616213', },
    { filterId: '1655438', author: '颜语', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/67a8292ae2a78680cdab0b2c1e86c096.jpg?x-oss-process=image/resize,w_200', name: '重生后，七个兄长跪着求原谅番外', id: '11616219', },
    { filterId: '1666661', author: '小龙的笔', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/b337/4ee412e1c6911f2f8ef3adb14dc7a046.jpg?x-oss-process=image/resize,w_200', name: '表白你不同意，变心你哭什么番外', id: '11616171', },
    { filterId: '1995023', author: '青岳', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/54a8fb8044c2a6de7b5ba0c7da592c4c.jpg?x-oss-process=image/resize,w_200', name: '边关兵王番外', id: '11616087', },
    { filterId: '1832321', author: '妖道无涯', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/d0bddfe10fe3355bd73eaa62c66dab34.jpg?x-oss-process=image/resize,w_200', name: '重生1958：从窝在深山打猎开始番外', id: '11619165', },
    { filterId: '1949695', author: '沙子', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/b981ee2702b6a294a497e9b1da2c5d8b.jpg?x-oss-process=image/resize,w_200', name: '被贵妃配给太监当对食后番外', id: '11616099', },
    { filterId: '1742005', author: '独步寻梦', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/d2e17f3059e0f3c7d0fb4bd32cff48ae.jpg?x-oss-process=image/resize,w_200', name: '离婚后，渣爹做梦都在偷妈咪番外', id: '11616156', },
    { filterId: '2038385', author: '封情老衲', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/e2d1a039401e33f04df5d4b3bbefa832.jpg?x-oss-process=image/resize,w_200', name: 'SSSSSSSSSSSSS级镇狱狂龙番外', id: '11616063', },
    { filterId: '1806418', author: '万红壮', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/2bbd178818006d9dd2acf4c395326fdf.jpg?x-oss-process=image/resize,w_200', name: '躺平：老婆修炼我变强番外', id: '11616147', },
    { filterId: '1692604', author: '我是宝宝', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/d42c1d3f7ff22e441db915325dc37ffa.jpg?x-oss-process=image/resize,w_200', name: '娇气小祖宗，禁欲大叔拿命哄番外', id: '11616165', },
    { filterId: '2028957', author: '推窗望岳', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/ad00841cc329231dc5e5d63bac9bfa63.jpg?x-oss-process=image/resize,w_200', name: '桃花劫番外', id: '11619150', },
    { filterId: '1581221', author: '鱼生', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/1a6e077ffea3a2aebf8f44ef7b56e398.jpg?x-oss-process=image/resize,w_200', name: '巅峰荣耀番外', id: '11619189', },
    { filterId: '1971019', author: '舒莓', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/03a61608dabf2789d9d60f96812662ec.jpg?x-oss-process=image/resize,w_200', name: '七零易孕娇娇女，馋哭绝嗣京少番外', id: '11616096', },
    { filterId: '1691418', author: '仄言小可爱', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/ebb2dd916117424e15d624f9bf56b682.jpg?x-oss-process=image/resize,w_200', name: '失幻番外', id: '11616177', },
    { filterId: '2040951', author: '狗肠', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/9bf3/f64c52e4085a6f8178a1566d7205bc39.jpg?x-oss-process=image/resize,w_200', name: '天才小师姐她偏要当废物番外', id: '11616066', },
    { filterId: '1582374', author: '是心动啊', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/138b9dfbc1f2baaf19841657dd051ab6.jpg?x-oss-process=image/resize,w_200', name: '嚣张王妃自请下堂番外', id: '11616237', },
    { filterId: '1839533', author: '温流', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/217f5768b9b74867684885c79d0413fd.jpg?x-oss-process=image/resize,w_200', name: '锦帐春深番外', id: '11616132', },
    { filterId: '1836527', author: '蓝九九', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/76422d7860262cc5a791366aed1538f7.jpg?x-oss-process=image/resize,w_200', name: '凰宫梦番外', id: '11616135', },
    { filterId: '1839254', author: '易小文', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/536b75bc17b9086c2336f4059d6fa3bf.jpg?x-oss-process=image/resize,w_200', name: '妻女死祭，渣总在陪白月光孩子庆生番外', id: '11616138', },
    { filterId: '1569859', author: '妖六六', img: 'https://cdn.wtzw.com/bookimg/public/images/cover/a3c6/33d38e118b41c82c593205037260b9ca.jpg?x-oss-process=image/resize,w_200', name: '暴力医妃飒且甜番外', id: '11620341', }
];

// 普通站点排序（站点id）
export const normalSiteSortList = [3, 4, 7, 8, 13, 14, 15, 16, 20, 22, 23, 25, 26, 30, 31, 33, 34, 37, 38, 39];

type NormalSiteBookIdInput = string | number | null | undefined;

/**
 * 匹配书架中的id，存在优先展示，不存在则展示默认数据
 */
export const getNormalSiteBookDefault = (inputBookIds: NormalSiteBookIdInput[] = []): Record<number, NormalSiteBookItem> => {
    const validBookIds = Array.from(new Set(inputBookIds.filter((id) => id !== '' && id !== null && id !== undefined).map((id) => String(id))));
    const hitFilterIdSet = new Set(validBookIds);
    const hitList: NormalSiteBookItem[] = [];
    const unHitList: NormalSiteBookItem[] = [];
    for (const item of normalSiteBookDefaultRaw) {
        if (hitFilterIdSet.has(item.filterId)) {
            hitList.push(item);
        } else {
            unHitList.push(item);
        }
    }
    const sortedList = hitList.concat(unHitList);

    return normalSiteSortList.reduce((result, site, index) => {
        const book = sortedList[index];
        if (book) {
            result[site] = book;
        }
        return result;
    }, {} as Record<number, NormalSiteBookItem>);
};
